

 document.addEventListener("DOMContentLoaded", function() {
    // Select the product price element
    var priceElement = document.querySelector(".product-price");

    if (priceElement) {
      // Create the button container
      var buttonContainer = document.createElement("div");
      buttonContainer.classList.add("custom-buttons");
      buttonContainer.innerHTML = `
        
        <button class="add-to-cart">Add to Cart</button>
        <button class="buy-now">Buy Now</button>
      `;

      // Insert after the price element
      priceElement.insertAdjacentElement("afterend", buttonContainer);

      // Add click event listeners
      document.querySelector(".buy-now").addEventListener("click", function() {
        var buyNowButton = document.querySelector("#more-payment-options-link");
        if (buyNowButton) {
          buyNowButton.click();
        }
      });

      document.querySelector(".add-to-cart").addEventListener("click", function() {
        var addToCartButton = document.querySelector(".button-add-to-cart");
        if (addToCartButton) {
          addToCartButton.click();
        }
      });
    }
  });


  

  
  document.addEventListener("DOMContentLoaded", function() {
    
    Element.prototype.appendAfter = function(element) {
        element.parentNode.insertBefore(this, element.nextSibling);
    };
    
    var imgSrcs = [
        "https://cdn.shopify.com/s/files/1/0901/6334/7735/files/Group_5.png?v=1742894151",
        "https://cdn.shopify.com/s/files/1/0901/6334/7735/files/Group_4.png?v=1742894151",
        "https://cdn.shopify.com/s/files/1/0901/6334/7735/files/Group_3.png?v=1742894151"
    ];
    
    var badgeTexts = [
        "Free Shipping",
        "30 Day Returns",
        "Premium Warranty"
    ];
    
    var popup = ["simple-shipping", "simple-return", "simple-warranty"];
    
    var container = document.createElement('div');
    container.className = 'heavenly-badges-outer-container';
    var imgContainer = document.createElement('div');
    imgContainer.className = 'heavenly-img-container';
    
    var y = document.querySelector('.product-buy-buttons');
    if (!document.querySelector('.heavenly-img-container')) {
        container.appendAfter(y);
        container.appendChild(imgContainer);
    }
    
    imgSrcs.forEach((src, i) => {
        var img = document.createElement('div');
        img.innerHTML = `<div class="heavenly-badge-container"><img src="${imgSrcs[i]}"><span class="badge${i}" id="${popup[i]}">${badgeTexts[i]}</span></div>`;
        img.className = "heavenly-badges-container";
        imgContainer.appendChild(img);
    });
});

// document.addEventListener("DOMContentLoaded", function() {
//     var atc = 0;
//     var timeratc = setInterval(function() {
//         if (!document.querySelector('.simple-badges')) {
//             var popupDiv1 = document.createElement('div');
//             popupDiv1.className = "simple-popup simple-return-popup";
//             popupDiv1.innerHTML = `
//                 <div class="popup-content">
//                     <div class="popup-title">Refund policy
// <span class="simple-close">×</span></div>
//                     <div class="popup-p">
//                         <div class="popup-contentt"><div class="rte prose max-w-none">
//         <p>1. If an order is canceled prior to shipment, payment will be fully refunded. After products are shipped, cancellations are treated as returns as described below.</p>
// <p><span>2. Shipping charges on returns shall be the responsibility of the customer and all returned items must be returned in “new” or “like new” condition, in undamaged original manufacturer’s packaging, and with all original product manuals. After the product is received, inspected and verified to be in “like new” condition, a full refund will be provided on the product purchase price.</span><br></p>
// <p>3. If you refuse an item delivered for any reason other than damaged merchandise or a shipping error by us, the item shall be treated as a return and charges described in Section 2 above shall be applied.</p>
// <p>4. The customer must notify the business of intent to return through email or phone within 30 days of receiving the product. Customer must schedule the pick-up within 5 business days of notification.&nbsp;</p>
//     </div></div>
//                     </div>
//                 </div>`;

//            var popupDiv2 = document.createElement('div');
//             popupDiv2.className = "simple-popup simple-warranty-popup";
//             popupDiv2.innerHTML = `
//                 <div class="popup-content">
//                     <div class="popup-title">Warranty
//                       <span class="simple-close">×</span>
//                     </div>
//                     <div class="popup-p">
//                       <div class="popup-contentt"><div class="my-4  prose max-w-none">
//         <p><strong>Heavenly Heat Saunas Limited Warranty</strong></p><p>Heavenly Heat Saunas (“Company”) offers the following warranty to the original purchaser of any Heavenly Heat Saunas-manufactured or distributed saunas (“Sauna”) and designated parts and accessories.</p><h3><strong>Product Warranty Coverage</strong></h3><p>Product Type: Indoor Saunas &amp; Outdoor Saunas</p><p><strong>Sauna Cabin </strong>(Carpentry/Wood)<strong>: </strong>10 Years</p><p><strong>Factory-Installed Electrical Components </strong>(Including Heaters): 6 Years</p><p><strong>Labor on Sauna Cabin </strong>(USA &amp; Canada only): 4 Years</p><p><strong>Non-Factory Installed Components, Options, Parts, and Accessories: </strong>2 Years. Per manufacturer’s warranty unless specified in Heavenly Heat Saunas’ quote, invoice, or website</p><p>For the specified warranty period, Heavenly Heat Saunas agrees to repair or replace, at its sole discretion, the products listed above, subject to and solely in accordance with the terms, conditions, exclusions, and limitations set forth herein.&nbsp;<strong>Please read this limited warranty in its entirety to understand your rights and obligations.</strong></p><h3><strong>Warranty on Sauna Cabin and Factory-Installed Components</strong></h3><p>Heavenly Heat Saunas warrants to the original purchaser during the warranty period that:</p><ul><li>The&nbsp;<strong>Sauna Cabin</strong>&nbsp;will maintain its structural integrity, and for outdoor models, that it will not leak.</li><li><strong>Factory-Installed Components</strong>&nbsp;(e.g., heaters, controls, power supply, and electrical wiring) will be free from defects in materials and workmanship.</li></ul><p>This limited warranty applies only to saunas installed within six months of the delivery date.</p><h3><strong>Labor Warranty for Sauna Cabin and Factory-Installed Components</strong></h3><p>Labor coverage for repair or replacement is provided for the specified labor warranty period within the USA and Canada only.</p><h3><strong>Non-Factory Installed Components, Options, Parts, and Accessories</strong></h3><p>Non-factory installed components and Heavenly Heat Saunas options, parts, and accessories are warranted solely as set forth in the manufacturer’s warranty, if any, and as stated in the final quote or invoice from Heavenly Heat Saunas. Please consult the manufacturer directly for any items not explicitly covered by Heavenly Heat Saunas.</p><h3><strong>Warranty Exclusions and Limitations</strong></h3><p>This warranty does not cover:</p><ul><li><strong>Damage from delivery services, mishandling, or improper installation</strong>&nbsp;by third parties or users.</li><li><strong>Environmental factors or improper maintenance</strong>&nbsp;of outdoor saunas, including exposure to elements like snow and water.</li><li><strong>Acts of God</strong>&nbsp;(e.g., floods, lightning) and&nbsp;<strong>normal wear and tear</strong>.</li><li><strong>Costs associated with labor, transportation, or reinstallation</strong>&nbsp;outside of specified terms.</li><li><strong>Consequential damages, losses, or commercial loss</strong>, whether direct or indirect.</li></ul><p>This warranty is non-transferable and may only be claimed by the original purchaser. Proof of purchase is required for any warranty claims. Requests to transfer warranty must be approved in writing by the company.</p><h3><strong>Disclaimer of Implied Warranties</strong></h3><p>ALL IMPLIED WARRANTIES, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, ARE HEREBY DISCLAIMED OR LIMITED TO THE FULLEST EXTENT ALLOWED BY LAW.</p>
//       </div></div>
//                     </div>
//                 </div>`;
//             document.body.appendChild(popupDiv1);
          
//             document.body.appendChild(popupDiv2);
            
//             document.getElementById("simple-return").addEventListener("click", function(e) {
//                 e.stopPropagation();
//                 document.querySelector('.simple-return-popup').classList.add('open');
//             });
//              document.getElementById("simple-warranty").addEventListener("click", function(e) {
//                 e.stopPropagation();
//                 document.querySelector('.simple-warranty-popup').classList.add('open');
//             });
            
//             document.querySelectorAll(".simple-close").forEach(closeBtn => {
//                 closeBtn.addEventListener("click", function() {
//                     this.closest(".simple-popup").classList.remove("open");
//                 });
//             });
            
//             document.querySelectorAll(".simple-popup").forEach(popup => {
//                 popup.addEventListener("click", function(event) {
//                     event.stopPropagation();
//                 });
//             });
            
//             window.addEventListener("click", function() {
//                 if (document.querySelector("body > .open")) {
//                     document.querySelector(".simple-close").click();
//                 }
//             });
            
//             clearInterval(timeratc);
//         }
        
//         if (atc > 200) {
//             clearInterval(timeratc);
//         }
//         atc++;
//     }, 50);
// });




document.addEventListener("DOMContentLoaded", function () {
    const footer = document.createElement("div");
    footer.classList.add("heavenly-sticky-footer");
    footer.innerHTML = `
        <div class="heavenly-footer-content">
            <div class="heavenly-footer-text">
                <span class="heavenly-product-name"></span>
                <span class="heavenly-product-price"></span>
            </div>
            <button class="heavenly-add-to-cart">ADD TO CART</button>
        </div>
    `;
    document.body.appendChild(footer);

    const productNameElement = document.querySelector(".product-name-wrapper h1.h2");
    const productPriceElement = document.querySelector("span.regular-price");
    const addToCartButton = document.querySelector(".button-add-to-cart");
    const referenceElement = document.querySelector("button.add-to-cart");

    if (productNameElement && productPriceElement) {
        document.querySelector(".heavenly-product-name").textContent = productNameElement.textContent;
        document.querySelector(".heavenly-product-price").textContent = productPriceElement.textContent;
    }

    document.querySelector(".heavenly-add-to-cart").addEventListener("click", function () {
        if (addToCartButton) {
            addToCartButton.click();
        }
    });

    function toggleFooterVisibility() {
        if (!referenceElement) return;

        const referenceBottom = referenceElement.getBoundingClientRect().bottom + window.scrollY;
        const scrollPosition = window.scrollY;

        if (scrollPosition > referenceBottom) {
            footer.classList.add("visible"); // Show footer when scrolled past add-to-cart button
            addTidioStyles();
        } else {
            footer.classList.remove("visible"); // Hide footer if above the add-to-cart button
            removeTidioStyles();
        }
    }

    function addTidioStyles() {
        let styleTag = document.getElementById("tidio-dynamic-style");
        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "tidio-dynamic-style";
            document.head.appendChild(styleTag);
        }
        styleTag.innerHTML = `
            iframe#tidio-chat-iframe {
                height: 120px !important;
                bottom: 100px !important;
            }
            @media screen and (max-width: 768px) {
                iframe#tidio-chat-iframe {
                    height: 150px !important;
                    bottom: 130px !important;
                }
            }
        `;
    }

    function removeTidioStyles() {
        const styleTag = document.getElementById("tidio-dynamic-style");
        if (styleTag) {
            styleTag.remove();
        }
    }

    window.addEventListener("scroll", toggleFooterVisibility);
    toggleFooterVisibility(); // Run once on load in case user starts mid-page
});






document.addEventListener("DOMContentLoaded", function () {
    const ratingText = document.querySelector(".product-info .rating-text span");
    if (ratingText) {
        let text = ratingText.textContent.trim(); // Remove extra spaces
        let numberMatch = text.match(/\d+/); // Extract the number

        if (numberMatch) {
            ratingText.textContent = `(${numberMatch[0]} Customer Reviews)`;
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product-carousel-wrapper .rating-text span").forEach(span => {
        let match = span.textContent.match(/\((\d+)\)/); // Match number inside parentheses
        if (match) {
            span.textContent = `(${match[1]} Reviews)`;
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".products-collection-grid .rating-text span").forEach(span => {
        let match = span.textContent.match(/\((\d+)\)/); // Match number inside parentheses
        if (match) {
            span.textContent = `(${match[1]} Reviews)`;
        }
    });
});




document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth < 1024) {
        return; // Exit script if screen width is less than 1024px (tablet/mobile)
    }

    const productMedia = document.querySelector(".product-media-carousel");
    const container = document.querySelector(".product-media.color.product-media--lightbox");
    const stopSection = document.querySelector(".section-main-product + .section-main-product-details + *");

    if (!productMedia || !container || !stopSection) {
        console.error("One or more elements not found.");
        return;
    }

    const marginTop = 20; // Space from top when sticky
    const stopOffsetAdjustment = 64; // Stop sticky 64px before stopSection
    const mediaHeight = productMedia.offsetHeight;

    // Store the initial width of productMedia on load
    const initialWidth = productMedia.offsetWidth + "px";

    function updatePosition() {
        const scrollY = window.scrollY;
        const containerTop = container.getBoundingClientRect().top + window.scrollY;
        const stopOffset = stopSection.getBoundingClientRect().top + window.scrollY - stopOffsetAdjustment;
        const containerBottom = stopOffset - mediaHeight - marginTop;

        if (scrollY >= containerTop - marginTop && scrollY < containerBottom) {
            productMedia.style.position = "fixed";
            productMedia.style.top = `${marginTop}px`;
            productMedia.style.width = initialWidth; // Keep consistent width
        } else if (scrollY >= containerBottom) {
            productMedia.style.position = "absolute";
            productMedia.style.top = `${stopOffset - mediaHeight}px`;
            productMedia.style.width = initialWidth; // Keep consistent width
        } else {
            productMedia.style.position = "static";
            productMedia.style.width = initialWidth; // Preserve the same width even in static
        }
    }

    window.addEventListener("scroll", updatePosition);
    window.addEventListener("resize", function () {
        if (window.innerWidth < 1024) {
            productMedia.style.position = "static"; // Reset on mobile
            productMedia.style.width = "auto"; // Allow it to be responsive
            return;
        }
        updatePosition();
    });

    updatePosition();
});





document.addEventListener("DOMContentLoaded", function () {
    console.log("Script Loaded");

    function updateRating() {
        const ratingElement = document.querySelector(".jdgm-rev-widg__summary-average");

        if (!ratingElement) {
            console.warn("Waiting for rating element...");
            return;
        }

        console.log("Found rating element:", ratingElement.textContent);

        // Extract numerical rating
        let ratingText = ratingElement.textContent.match(/[\d.]+/);
        if (!ratingText) {
            console.error("Rating text not found in element:", ratingElement.textContent);
            return;
        }

        let rating = parseFloat(ratingText[0]);
        if (isNaN(rating)) {
            console.error("Failed to parse rating as a number.");
            return;
        }

        let roundedRating = rating.toFixed(1);
        console.log("Original Rating:", rating, "Rounded Rating:", roundedRating);

        // Create new design elements
        const ratingContainer = document.createElement("div");
        ratingContainer.classList.add("custom-rating-container"); // Add class
        ratingContainer.style.display = "flex";
        ratingContainer.style.alignItems = "center";
        ratingContainer.style.gap = "6px";

        const ratingBox = document.createElement("span");
        ratingBox.classList.add("custom-rating-box"); // Add class
        ratingBox.textContent = roundedRating;
        ratingBox.style.backgroundColor = "#169895"; // Adjust color to match design
        ratingBox.style.color = "white";
        ratingBox.style.padding = "4px 8px";
        ratingBox.style.fontWeight = "bold";

        // Append to rating container
        ratingContainer.appendChild(ratingBox);

        // Replace the existing rating element with the new one
        ratingElement.replaceWith(ratingContainer);
    }

    // Check for the element periodically
    const observer = new MutationObserver(() => {
        if (document.querySelector(".jdgm-rev-widg__summary-average")) {
            observer.disconnect(); // Stop checking once found
            updateRating();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Run once in case the element is already loaded
    updateRating();
});
